import { faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import styled from "styled-components";

interface TabHeaderTitleProps {
    title: string;
    onClick: () => void;
}

const TabHeaderRow = styled(Row)`
    @media (max-width: 768px) {
        gap: 16px !important;

        .tab-title {
            font-size: 21px;
        }
    }
`;

export const TabHeaderTitle = ({ title, onClick }: TabHeaderTitleProps) => {
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const local = useLocation();

    useEffect(() => {
        setIsEdit(!local.pathname.includes("/novo"))
    }, [isEdit]);

    return (
        <>
            {isEdit &&
                <TabHeaderRow className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between mt-4">
                    <Col>
                        <span className="tab-title">{title}</span>
                    </Col>
                    <Col className="d-flex justify-content-start justify-content-md-end mt-2 mt-md-0">
                        <Button className="btn-view" onClick={onClick}>
                            <FontAwesomeIcon icon={faEye} />
                            Visualizar
                        </Button>
                    </Col>
                </TabHeaderRow>
            }
        </>
    );
};